import React, { useRef, useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import { createTheme } from "@mui/material";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import InfoIcon from '@mui/icons-material/Info';
import RefreshIcon from '@mui/icons-material/Refresh';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
    KeyboardTimePicker,
} from '@material-ui/pickers';

const materialTheme = createTheme(({
    // set default for now
}));

const useStyles = makeStyles((theme) => ({
    fullWidth: {
        width: "100%"
    },
    input: {

    },

}));

function MethodDelivery(props) {
    const classes = useStyles();
    const [requestedDeliveryDate, setRequestedDeliveryDate] = React.useState(new Date());
    const [requestedDeliveryDateCalenderOpen, setRequestedDeliveryDateCalenderOpen] = useState(false);

    const [preparedDeliveryTime, setPreparedDeliveryTime] = useState(new Date());
    const [preparedDeliveryTimeCalenderOpen, setPreparedDeliveryTimeCalenderOpen] = useState(false);


    const requestedDeliveryDateHandleDateChange = (date) => {
        setRequestedDeliveryDate(date);

    };

    const deliveryTimeHandleDateChange = (date) => {
        setPreparedDeliveryTime(date);
    };

    return (
        <div>
            <Grid container spacing={1}>
                <Grid item xs={12} >Request Delivery Date</Grid>
                <Grid item xs={12}>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={materialTheme}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    className={classes.fullWidth}
                                    margin="normal"
                                    id="date-picker-dialog"
                                    inputVariant="outlined"
                                    format="MMMM d, yyyy"
                                    InputProps={{ readOnly: true }}
                                    onClick={() => setRequestedDeliveryDateCalenderOpen(true)}
                                    value={requestedDeliveryDate}
                                    open={requestedDeliveryDateCalenderOpen}
                                    onOpen={() => setRequestedDeliveryDateCalenderOpen(true)}
                                    onClose={() => setRequestedDeliveryDateCalenderOpen(false)}
                                    onChange={requestedDeliveryDateHandleDateChange}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </ThemeProvider>
                    </StyledEngineProvider>
                </Grid>

                <Grid item xs={12} >Preferred Time</Grid>
                <Grid item xs={12}>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={materialTheme}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardTimePicker
                                    className={classes.fullWidth}
                                    margin="normal"
                                    id="time-picker"
                                    inputVariant="outlined"
                                    InputProps={{ readOnly: true }}
                                    value={preparedDeliveryTime}
                                    onClick={() => { setPreparedDeliveryTimeCalenderOpen(true) }}
                                    open={preparedDeliveryTimeCalenderOpen}
                                    onOpen={() => setPreparedDeliveryTimeCalenderOpen(true)}
                                    onClose={() => setPreparedDeliveryTimeCalenderOpen(false)}
                                    onChange={deliveryTimeHandleDateChange}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change time',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </ThemeProvider>
                    </StyledEngineProvider>
                </Grid>
                <Grid item xs={12} >Delivery Location</Grid>
                <Grid item xs={12}>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={materialTheme}>
                            <TextField
                                className={classes.fullWidth}
                                id="outlined-multiline-static"
                                multiline
                                rows={4}
                                variant="outlined"
                            />
                        </ThemeProvider>
                    </StyledEngineProvider>
                </Grid>
                <Grid item xs={12} >Contact Name</Grid>
                <Grid item xs={12}>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={materialTheme}>
                            <TextField
                                className={classes.fullWidth}
                                id="contact-name"
                                rows={4}
                                variant="outlined"
                            />
                        </ThemeProvider>
                    </StyledEngineProvider>
                </Grid>

                <Grid item container >
                    <Grid item xs>
                        <Typography variant="subtitle1">Delivery Charge</Typography>
                    </Grid>
                    <Grid item style={{ marginRight: "1.5em" }}>
                        <InfoIcon />
                    </Grid>
                </Grid>
                <Grid item container >
                    <Grid item xs container>
                        <Button variant="contained" color="primary">
                            Request Quote
                        </Button>
                        <Typography variant="h6" style={{ marginLeft: "1rem" }}>500</Typography>
                    </Grid>
                    <Grid item style={{ marginRight: "1.5em" }}>
                        <RefreshIcon />
                    </Grid>
                </Grid>

                <Grid item container >
                    <Grid item xs>
                        <Typography variant="subtitle1">Other Charges</Typography>
                    </Grid>
                    <Grid item style={{ marginRight: "1.5em" }}>
                        <InfoIcon />
                    </Grid>
                </Grid>
                <Grid item container >
                    <Grid item xs container>
                        <Button variant="contained" color="primary">
                            Request Quote
                        </Button>
                        <Typography variant="h6" style={{ marginLeft: "1rem" }}>0</Typography>
                    </Grid>
                    <Grid item style={{ marginRight: "1.5em" }}>
                        <RefreshIcon />
                    </Grid>
                </Grid>

                <Grid item container >
                    <Grid item xs>
                        <Typography variant="subtitle1">Payment Type</Typography>
                    </Grid>
                    <Grid item style={{ marginRight: "1.5em" }}>
                        <InfoIcon />
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={materialTheme}>
                            <TextField
                                className={classes.fullWidth}
                                id="contact-name"
                                rows={4}
                                variant="outlined"
                            />
                        </ThemeProvider>
                    </StyledEngineProvider>
                </Grid>

                <Grid item container >
                    <Grid item xs>
                        <Typography variant="subtitle1">Proof of Payment</Typography>
                    </Grid>
                </Grid>
                <Grid item container >
                    <input
                        accept="image/*"
                        id="contained-button-file"
                        type="file"
                    />
                </Grid>

                <Grid item container >
                    <Grid item xs>
                        <Typography variant="subtitle1">Ordered Products</Typography>
                    </Grid>
                    <Grid item style={{ marginRight: "1.5em" }}>
                        <Typography variant="subtitle1">4,718.00</Typography>
                    </Grid>
                </Grid>
                <Grid item container >
                    <Grid item xs>
                        <Typography variant="subtitle1">Delivery Charge</Typography>
                    </Grid>
                    <Grid item style={{ marginRight: "1.5em" }}>
                        <Typography variant="subtitle1">0.00</Typography>
                    </Grid>
                </Grid>
                <Grid item container >
                    <Grid item xs>
                        <Typography variant="subtitle1">Other Charges</Typography>
                    </Grid>
                    <Grid item style={{ marginRight: "1.5em" }}>
                        <Typography variant="subtitle1">0.00</Typography>
                    </Grid>
                </Grid>
                <Grid item container >
                    <Grid item xs>
                        <Typography variant="subtitle1">Discount</Typography>
                    </Grid>
                    <Grid item style={{ marginRight: "1.5em" }}>
                        <Typography variant="subtitle1">0.00</Typography>
                    </Grid>
                </Grid>
                <Grid item container >
                    <Grid item xs>
                        <Typography variant="subtitle1">Grand Total</Typography>
                    </Grid>
                    <Grid item style={{ marginRight: "1.5em" }}>
                        <Typography variant="subtitle1">4,718.00</Typography>
                    </Grid>
                </Grid>
                <Grid item container >
                <Button variant="contained" color="primary" style={{width:"100%"}} onClick={()=>{props.closeAllDialog()}}>
                    Place Order
                </Button>
                </Grid>
            </Grid>
        </div>
    );

}

export default MethodDelivery